<h2>Share Payment Link</h2>
<div>
    <form class="example-form" [formGroup]="PaymentLinkForm" (submit)="sendPaymentLink()">
        <table class="example-full-width" cellspacing="0"><tr>
            <td>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Patient Name</mat-label>
                    <input matInput [readonly]="true" formControlName="patient_name">
                  </mat-form-field>
           </td>
            <td>
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Mobile</mat-label>
                    <input matInput [readonly]="true" formControlName="mobile">
                  </mat-form-field>
            </td>
          </tr></table>
        <p>
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Amount</mat-label>
            <input matInput formControlName="amount">
          </mat-form-field>
          <mat-form-field class="example-full-width" appearance="fill" style="display: none;">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description"></textarea>
          </mat-form-field>
        </p>
        
         <p>
          
         <button type="submit" [disabled]="loading"  class="btn btn-success ml-2 mb-4"> <i class="fa fa-share mr-2" [ngClass]="{'fa-spin':loading}"></i>Share Payment Link</button>
          <button type="button" class="btn btn-danger ml-2 mb-4" (click)="closeDialog()"> <i class="fa fa-times mr-2"></i>Close</button>
        </p>
        
      </form>
      <div *ngIf="show_copy">
        <button type="button" class="copy_btn" (click)="copyToClipboard(sharableLink)">Copy link</button>
        <input readonly type="text" [(ngModel)]="copypaymentlink" #sharableLink>
      </div>
</div>

